module.exports = __webpack_public_path__ + "static/media/familia-martins-1954.5b4c7503.webp";